import { render, staticRenderFns } from "./BoxPieCharts.vue?vue&type=template&id=09414262&scoped=true&"
import script from "./BoxPieCharts.vue?vue&type=script&lang=js&"
export * from "./BoxPieCharts.vue?vue&type=script&lang=js&"
import style0 from "./BoxPieCharts.vue?vue&type=style&index=0&id=09414262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09414262",
  null
  
)

export default component.exports